import React from 'react';
import { Plugin, CustomEditor } from '../types';

const CodeBlockPlugin: Plugin = {
  name: 'codeBlock',
  
  commands: {
    insertCodeBlock: (editor: CustomEditor, language?: string) => {
      // TODO: Implement code block insertion
      console.log('Insert code block:', language);
    }
  }
};

export default CodeBlockPlugin; 